import "./EnterAddress.less";

import React, { Component } from "react";
import $ from "jquery";
import { Link } from "react-router-dom";
import { translate } from "react-i18next";
import queryString from "query-string";
import { ForgottenProviderContext } from "../../../contexts/contexts";
import config from "../../../config";

class EnterAddress extends Component {
	static contextType = ForgottenProviderContext;

	state = {
		email: ""
	};

	render() {
		const t = this.props.t;

		return (
			<div className="enter-address">
				<p className="header">{t("description")}</p>

				<form onSubmit={this.handleSubmitClick} noValidate>
					<input type="email" value={this.state.email} placeholder={t("emailPlaceholder")} onChange={this.handleEmailInputChange} />
					{this.state.showError && <p className="error">{this.state.errorMessage}</p>}
					<button type="submit" className="primarybtn">
						{t("submitButton")}
					</button>
				</form>

				<div className="login-link-holder">
					<Link to="/login">{t("backToLogin")}</Link>
				</div>
			</div>
		);
	}

	handleEmailInputChange = event => {
		this.setState({ email: event.target.value });
	}

	handleSubmitClick = e => {
		const t = this.props.t;

		e.preventDefault();

		if ((this.state.email || '').trim().length === 0) {
			this.setState({ showError: true, errorMessage: t('emailAddressRequired') });
			return;
		}
		
		this.setState({ showError: false, errorMessage: '' });

		const currentQuery = queryString.parse(window.location.search);
		const returnUrl = currentQuery.returnUrl;

		$.post(`${config.identityServer.baseUrl}/Portal/ForgottenPassword`, {
			email: this.state.email,
			clientId: currentQuery.clientId || config.identityServer.clientId,
			culture: config.language + "-BE",
			returnUrl: returnUrl
		},
		result => {
			if (!result.success) {
				if (result.knownAccountWithoutEmail) {
					// No Scoodle password yet
					this.props.goToStep(3);
					this.context.setProvider(result.knownAccountProvider);
				}
				else {
					this.setState({ showError: true, errorMessage: t(result.errorCode) });
				}
			}
			else {
				// We sent validation email
				this.props.nextStep();
			}
		})
		.fail(() => {
			this.setState({ showError: true, errorMessage: t('unexpectedError') });
		});
	};
}

export default translate("enterAddress")(EnterAddress);



// WEBPACK FOOTER //
// ./src/components/ForgottenPassword/EnterAddress/EnterAddress.js